/*
status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import CapacityUtilisationChartAPI from '../api/capacityUtilisationChart';

const state = {
    dialogVisible: false,
    utilisationData: [],
    utilisationDataLoadStatus: 0,
    journeyRequestIds: [],
};

const actions = {
    updateDialogVisible( { commit }, value ){
        commit( 'setDialogVisible', value );
    },
    updateJourneyRequestIds( { commit }, value ){
        commit( 'setJourneyRequestIds', value );
    },
    getUtilisationData ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('setUtilisationDataLoadStatus', 1);

            CapacityUtilisationChartAPI.getData( { journey_request_ids: state.journeyRequestIds } )
                .then(response => {
                    commit('setUtilisationData', response.data.data);
                    commit('setUtilisationDataLoadStatus', 2);
                    resolve();
                })
                .catch(() => {
                    commit('setUtilisationData', []);
                    commit('setUtilisationDataLoadStatus', 3);
                    reject();
                });
        });
    },
};

const mutations = {
    setDialogVisible( state, status ){
        state.dialogVisible = status;
    },
    setJourneyRequestIds( state, ids ){
        state.journeyRequestIds = ids;
    },
    setUtilisationData( state, data ){
        state.utilisationData = data;
    },
    setUtilisationDataLoadStatus( state, status ){
        state.utilisationDataLoadStatus = status;
    },
};

const getters = {
};

export const capacityUtilisationCharts = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
